/**
 * Review
 * Todo:
 * Объеденить в один компонент и сделать роут с параметром типа: path: 'api/payment/:result'
 * и в зависимости от параметра менять 2 строки в шаблоне
 */
/**
 * Review
 * Todo:
 * Очень много неиспользуемых импортов
 */
import {
  Component, OnInit,} from '@angular/core';
import {DataService} from "../services/data.service";

import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/operator/delay';

import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import 'material-design-lite/material.min.js'
import {EditDataService, Info} from "../services/edit-data.service";
import {Http} from "@angular/http";
import {LoginService} from "../services/login.service";

@Component({
  selector: 'app-order',
  templateUrl: './paymentFail.component.html',
  styleUrls: ['./payment.component.css'],
  providers: [ToastsManager],

})

export class paymentFailure implements OnInit {
  public data: any = {};

  constructor( public router: Router,
              public editData: EditDataService, public toastr: ToastsManager,
              public loginService: LoginService) {
  }

  ngOnInit() {
    this.editData.getData().subscribe(data => this.data = data);
  }


  /**
   * Review
   * Todo:
   * Можно заменить на logout = this.loginService.logout;
   */
  logout() {
    this.loginService.logout();

  }


}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/payment/paymentFailure.component.ts